"use strict";

var _interopRequireDefault = require("/root/.jenkins/workspace/web-ug-admin-dev/node_modules/@babel/runtime/helpers/interopRequireDefault.js");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _objectSpread2 = _interopRequireDefault(require("/root/.jenkins/workspace/web-ug-admin-dev/node_modules/@babel/runtime-corejs2/helpers/objectSpread2.js"));
var _index = require("@/api/allianceAuthorization/index");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
var _default = exports.default = {
  name: 'Promotion',
  data: function data() {
    return {
      unionCode: '',
      id: '',
      ruleForm: {
        clientId: '',
        authEnabled: '',
        clientSecret: '',
        iosUniversalLink: '',
        redirectUri: ''
      },
      rules: {
        authEnabled: [{
          required: true,
          message: '请选择',
          trigger: 'change'
        }],
        clientId: [{
          required: true,
          message: '请输入clientId',
          trigger: 'blur'
        }],
        clientSecret: [{
          required: true,
          message: '请输入clientSecret',
          trigger: 'blur'
        }]
      }
    };
  },
  created: function created() {
    this.queryIt();
  },
  methods: {
    copy: function copy(val) {
      var _this = this;
      this.$copyText(val).then(function () {
        _this.$notify.success({
          title: '温馨提示',
          message: '拷贝成功'
        });
      }).catch(function () {
        _this.$notify.success({
          title: '温馨提示',
          message: '拷贝失败，请手动复制'
        });
      });
    },
    queryIt: function queryIt() {
      var _this2 = this;
      (0, _index.get_mt_config)({
        unionCode: 'MT'
      }).then(function (res) {
        if (res.data.configList.length > 0) {
          _this2.id = res.data.configList[0].id;
          _this2.unionCode = res.data.configList[0].unionCode;
          _this2.ruleForm = (0, _objectSpread2.default)({}, res.data.configList[0].config);
        }
      });
    },
    submitForm: function submitForm(formName) {
      var _this3 = this;
      this.$refs[formName].validate(function (valid) {
        if (valid) {
          _this3.$confirm('是否确认保存此配置?', '提示', {
            confirmButtonText: '确定',
            cancelButtonText: '取消',
            type: 'warning'
          }).then(function () {
            (0, _index.save_mt_config)({
              id: _this3.id,
              unionCode: _this3.unionCode,
              config: _this3.ruleForm
            }).then(function (res) {
              if (res.data) {
                _this3.$notify.success({
                  title: '温馨提示',
                  message: '操作成功'
                });
                _this3.queryIt();
              }
            });
          });
        } else {
          return false;
        }
      });
    }
  }
};